export default "__VITE_ASSET__3e12fe53__"